import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthService } from './auth.service';
import { EndpointBase } from './endpoint-base.service';
import { ConfigurationService } from './configuration.service';
import { Programme } from '../models/programme.model';


@Injectable()
export class ProgrammesEndpoint extends EndpointBase {

  constructor(private configurations: ConfigurationService, http: HttpClient, authService: AuthService) {
    super(http, authService);
  }

  getProgrammesEndpoint<T>(): Observable<T> {
    const endpointUrl = `${this.configurations.baseUrl}/api/programme/programmes`;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getProgrammesEndpoint());
      }));
  }

  getCompetencesParProgrammeEndpoint<T>(programmeId: number): Observable<T> {
    const endpointUrl = `${this.configurations.baseUrl}/api/programme/${programmeId}/competences`;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getCompetencesParProgrammeEndpoint(programmeId));
      }));
  }

  updateProgrammeEndpoint<T>(id: number, prog: Programme): Observable<T> {
    const endpointUrl = `${this.configurations.baseUrl}/api/programme/${prog.programmeId}`;

    return this.http.put<T>(endpointUrl, JSON.stringify(prog), this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.updateProgrammeEndpoint(id, prog));
      }));
  }

  createProgrammeEndpoint<T>(prog: Programme): Observable<T> {
    const endpointUrl = `${this.configurations.baseUrl}/api/programme`;

    return this.http.post<T>(endpointUrl, JSON.stringify(prog), this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.createProgrammeEndpoint(prog));
      }));
  }

  programmeExistEndpoint<T>(code: string): Observable<T> {
    const endpointUrl = `${this.configurations.baseUrl}/api/programme/code/${code}`;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.programmeExistEndpoint(code));
      }));
  }

  deleteProgrammeEndpoint<T>(id: number): Observable<T> {
    const endpointUrl = `${this.configurations.baseUrl}/api/programme/${id}`;

    return this.http.delete<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.deleteProgrammeEndpoint(id));
      }));
  }

  // --------- POUR LES TABLEAUX D'HARMONISATION -----------------

  getProgrammesActifsEndpoint<T>(): Observable<T> {
    const endpointUrl = `${this.configurations.baseUrl}/api/programme/programmes/actifs`;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getProgrammesActifsEndpoint());
      }));
  }

  getAllProgrammesAvecTableauxEndpoint<T>(programmeId: number): Observable<T> {
    const endpointUrl = `${this.configurations.baseUrl}/api/programme/programmes/tableaux/${programmeId}`;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getAllProgrammesAvecTableauxEndpoint(programmeId));
      }));
  }

  getProgrammesSansTableauxEndpoint<T>(programmeId: number): Observable<T> {
    const endpointUrl = `${this.configurations.baseUrl}/api/programme/programmes/sanstableaux/${programmeId}`;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getProgrammesSansTableauxEndpoint(programmeId));
      }));
  }


}

